<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
    <path
      d="M12.2499 10.0001C12.6641 10.0001 12.9999 10.3359 12.9999 10.7501C12.9998 11.1643 12.6641 11.5001 12.2499 11.5001H3.74989C3.33575 11.5001 2.99995 11.1643 2.99989 10.7501C2.99989 10.3359 3.33571 10.0002 3.74989 10.0001H12.2499Z"
      fill="#31D8B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.82948 1.79115C6.78922 0.11161 9.21057 0.11161 10.1703 1.79115L14.724 9.7599C15.6763 11.4265 14.4731 13.5001 12.5536 13.5001H3.44618C1.52676 13.5 0.323585 11.4265 1.27577 9.7599L5.82948 1.79115ZM9.30214 2.28724C8.72629 1.27952 7.27349 1.27952 6.69764 2.28724L2.14393 10.256C1.5727 11.2559 2.29459 12.5 3.44618 12.5001H12.5536C13.7053 12.5001 14.4272 11.2559 13.8558 10.256L9.30214 2.28724Z"
      fill="#31D8B0"
    />
  </svg>
</template>
